import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants.ts";

export const TopMenuStyled = styled.div.attrs(({ level }) => ({ className: level }))`
    display: flex;
    flex-wrap: wrap;
    align-self: stretch;
    
    &.second {
        background: transparent;
        
        .btn {
            background: transparent;
        }
    }
    
    .item {
        display: flex;
        color: var(--color-white-60);
        font-weight: 600;
        text-decoration: none;
        border-bottom: 2px solid transparent;
        padding: 8px 8px 6px;
        align-items: center;

        @media (max-width: ${BREAKPOINTS.medium}px) {
            padding: 8px 4px;
        }
        
        &:hover {
            color: var(--color-white-95);
        }
        
        &.active {
            color: var(--color-white-95);
            border-bottom-color: white;
        }
    }
`;
